import { takeLatest, call, put } from "redux-saga/effects";
import { UPDATE_CANDIDATE_RATING_REQUEST } from "../../actionTypes";

import {
  updateCandidateRatingSuccess,
  updateCandidateRatingFailure,
} from "./actions";
import AxiosInstance from "../../../services/AxiosInstance";
// Worker saga
function* updateCandidateRating(action) {
  try {
    const response = yield call(() =>
      AxiosInstance().post("/recruiter/candidate_rating", action.payload)
    );
    console.log("res", response.data);
    if (response.data.status == true) {
      yield put(updateCandidateRatingSuccess(response.data));
    } else {
      yield put(updateCandidateRatingFailure(response.data));
    }
  } catch (error) {
    yield put(
      updateCandidateRatingFailure({ status: false, message: error.message })
    );
  }
}

// Watcher saga
function* updateCandidateRatingSaga() {
  yield takeLatest(UPDATE_CANDIDATE_RATING_REQUEST, updateCandidateRating);
}
export default updateCandidateRatingSaga;
